var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 35,
    viewBox: "0 0 121 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00084 26.031C3.43409 26.031 0 23.9103 0 20.2473H5.61504C5.61504 21.5365 6.579 22.1631 7.86829 22.1631C8.98889 22.1631 9.65161 21.7655 9.65161 20.9702C9.65161 18.2952 0.301236 21.0666 0.301236 14.1261C0.301236 10.7523 3.40999 8.83643 7.50681 8.83643C11.9049 8.83643 15.2064 11.2825 15.2064 14.4515H9.57931C9.57931 13.4634 8.7479 12.7043 7.6273 12.7043C6.66335 12.7043 6.01268 13.1019 6.01268 13.7888C6.01268 16.1986 15.4956 13.6562 15.4956 20.5605C15.4956 24.079 12.2904 26.031 8.00084 26.031Z",
    fill: "#003A86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7273 23.344C43.7995 25.0671 42.0524 26.019 39.9076 26.019C36.6301 26.019 34.2202 24.0308 34.2202 20.0424V9.17383H40.6667V18.3917C40.6667 20.2111 41.3294 21.0666 42.5464 21.0666C43.8357 21.0666 44.4622 20.2111 44.4622 18.3917V9.17383H50.9087V25.6936H44.7273V23.344Z",
    fill: "#003A86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.027 16.6082L33.6299 9.17365H26.5207L23.0143 15.9816V0.871582L16.5679 4.13698V25.6935H23.0143V17.2347L26.822 25.6935H33.8588L29.027 16.6082Z",
    fill: "#003A86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.187 25.6936V9.17383H64.1513V25.6936H60.187Z",
    fill: "url(#paint0_linear_970_4005)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2969 12.4754C71.8147 12.4754 69.9711 14.4635 69.9711 17.4277C69.9711 20.3919 71.8147 22.3921 74.2969 22.3921C76.3814 22.3921 78.1647 21.1751 78.4901 18.7531H82.5869C82.3941 23.115 78.8877 26.0189 74.2969 26.0189C69.5373 26.0189 66.0068 22.4764 66.0068 17.4277C66.0068 12.379 69.5494 8.83643 74.2969 8.83643C78.7552 8.83643 82.1652 11.6078 82.5628 15.7408H78.3937C78.1286 13.5598 76.3814 12.4754 74.2969 12.4754Z",
    fill: "url(#paint1_linear_970_4005)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.334 25.6936V9.17383H88.2982V25.6936H84.334Z",
    fill: "url(#paint2_linear_970_4005)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3188 2.70333V25.6937H57.2831V0.703125L53.3188 2.70333Z",
    fill: "url(#paint3_linear_970_4005)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.036 9.17404L106.867 21.8983L102.734 9.17404H96.7691V4.14941L92.8048 6.14962V9.16199H90.166V12.6322H92.8048V25.7059H96.7691V12.6443H99.9502L104.975 27.3808C104.011 29.6942 102.854 30.7907 101.011 30.7907C100.215 30.7907 99.4561 30.6221 98.8296 30.4293V33.9357C99.4561 34.1284 100.42 34.2971 101.372 34.2971C105.565 34.2971 107.349 31.4896 108.746 27.4169L114.988 9.17404H111.036Z",
    fill: "url(#paint4_linear_970_4005)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6929 4.75172C59.6929 3.32988 60.7532 2.26953 62.1751 2.26953C63.633 2.26953 64.6572 3.32988 64.6572 4.75172C64.6572 6.1374 63.633 7.23391 62.1751 7.23391C60.7532 7.23391 59.6929 6.14945 59.6929 4.75172Z",
    fill: "url(#paint5_linear_970_4005)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8403 4.75172C83.8403 3.32988 84.9007 2.26953 86.3225 2.26953C87.7805 2.26953 88.8047 3.32988 88.8047 4.75172C88.8047 6.1374 87.7805 7.23391 86.3225 7.23391C84.9007 7.23391 83.8403 6.14945 83.8403 4.75172Z",
    fill: "url(#paint6_linear_970_4005)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M118.012 9.5472H117.47V11.451H117V9.5472H116.446V9.16162H118.085L118.012 9.5472Z",
    fill: "#003A86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.049 11.4631L119.964 10.2461C119.952 10.1015 119.952 9.98098 119.952 9.86049C119.928 9.99303 119.904 10.0774 119.868 10.2099L119.506 11.4631H119.109L118.783 10.2581C118.759 10.1497 118.711 9.98098 118.687 9.84844C118.687 9.98098 118.675 10.1135 118.675 10.2581L118.591 11.451H118.133L118.35 9.16162H118.94L119.241 10.3063C119.29 10.475 119.302 10.5473 119.326 10.6678C119.35 10.5473 119.374 10.4268 119.41 10.2943L119.723 9.16162H120.314L120.519 11.451H120.049V11.4631Z",
    fill: "#003A86"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_970_4005",
    x1: 52.8415,
    y1: 17.4319,
    x2: 110.338,
    y2: 17.4319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_970_4005",
    x1: 52.8414,
    y1: 17.4319,
    x2: 110.338,
    y2: 17.4319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_970_4005",
    x1: 52.8414,
    y1: 17.4319,
    x2: 110.337,
    y2: 17.4319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_970_4005",
    x1: 52.8415,
    y1: 13.199,
    x2: 110.338,
    y2: 13.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_970_4005",
    x1: 52.8414,
    y1: 19.2196,
    x2: 110.338,
    y2: 19.2196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_970_4005",
    x1: 52.8414,
    y1: 4.75701,
    x2: 110.337,
    y2: 4.75701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_970_4005",
    x1: 52.8417,
    y1: 4.75701,
    x2: 110.338,
    y2: 4.75701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    stopColor: "#FF0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d17c8a602ba99a4c8ff79aa34f0bc025.svg";
export { ForwardRef as ReactComponent };